export default __webpack_public_path__ + "static/media/Bandeira.46513561.jpg";